import React from 'react';
import firebase from 'firebase/app';

import { User } from '../contexts/user';

const useUserData = () => {
  const [userData, setUserData] = React.useState();
  const user = React.useContext(User);
  const uid = user?.uid;

  React.useEffect(() => {
    if (!uid) {
      return;
    }

    const userDataRef = firebase.database().ref(`userData/${uid}`);

    const cb = (snapshot) => {
      setUserData(snapshot.val());
    };

    userDataRef.on('value', cb);

    return () => {
      userDataRef.off('value', cb);
    };
  }, [uid]);

  return userData;
};

export default useUserData;
